import Sections from './Sections';
import { ContentBlock } from '../../types';

interface FormatTextProps {
    sections: ContentBlock[];
    url?: string;
}

export default function FormatText({ sections, url }: FormatTextProps): React.ReactElement | null {
    if (!sections?.length || !url) return null;

    return (
        <>
            {sections.map((section, i) => {
                if (section.type !== 'section') return null;

                return (
                    <Sections
                        key={i}
                        section={section}
                        index={i}
                        pageKey={url}
                    />
                );
            })}
        </>
    );
}
